import { render, staticRenderFns } from "./BreakdownTypeForm.vue?vue&type=template&id=435148bc"
import script from "./BreakdownTypeForm.vue?vue&type=script&lang=js"
export * from "./BreakdownTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports